<template>
  <action-dispatcher
    class="view-trail-lesson mb-5"
    action="courses/getLesson"
    loading-class="my-5"
    :parameters="{
      lesson_id: $route.params.id
    }"
  >
    <header v-if="featuredEpisode" :style="headerStyle">
      <div class="px-4 px-lg-5 py-5">
        <div class="row pt-5 mt-5">
          <div class="col-lg-4 col-md-6">
            <h3 class="text-light my-4">{{ featuredEpisode.name }}</h3>
            <button class="btn btn-primary btn-block btn-strong rounded-pill">
              PLAY
            </button>
          </div>
        </div>
      </div>
    </header>

    <div class="px-4 px-lg-5">
      <lesson-nav v-model="nav" />
    </div>

    <div v-if="nav === 'videos'" class="position-relative pb-5">
      <div class="px-4 px-lg-5">
        <swiper :navigation="true" :breakpoints="breakpoints">
          <swiper-slide v-for="video in videos" :key="video.id">
            <episode-slide
              :resource="video"
              :lesson="$route.params.id"
              :trail="$route.params.trail"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <div class="px-4 px-lg-5">
      <audios v-if="nav === 'audios'" :audios="audios" />
      <pdfs v-if="nav === 'pdfs'" :pdfs="pdfs" />
    </div>

    <transition name="fade">
      <pdf-reader
        v-if="reading"
        :resource="selectedFile"
        :lesson="lesson"
        @close="reading = false"
      />
    </transition>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import get from "lodash/get";
import isMobile from "ismobilejs";
import Swiper from "@/components/Swiper";
import SwiperSlide from "@/components/SwiperSlide";
import PdfReader from "@/components/lesson/PdfReader";
import Audios from "@/components/lesson/Audios";
import Pdfs from "@/components/lesson/Pdfs";
import LessonNav from "@/components/trail/LessonNav";
import EpisodeSlide from "@/components/trail/EpisodeSlide";

export default {
  components: {
    PdfReader,
    Audios,
    Pdfs,
    LessonNav,
    Swiper,
    SwiperSlide,
    EpisodeSlide
  },
  data() {
    return {
      nav: "videos",
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        },
        1600: {
          slidesPerView: 5
        }
      },
      reading: false,
      selectedFile: null
    };
  },
  computed: {
    ...mapState("courses", ["lesson", "categories"]),
    trail() {
      return this.categories.find(
        category => category.id === parseInt(this.$route.params.trail)
      );
    },
    resources() {
      return get(this.lesson, "resources", []);
    },
    videos() {
      return this.resources.filter(r => r.category_key === "videos");
    },
    audios() {
      return this.resources.filter(r => r.category_key === "audios");
    },
    pdfs() {
      return this.resources.filter(r => r.file_type === "pdf");
    },
    featuredEpisode() {
      return this.videos[0];
    },
    headerStyle() {
      if (!this.featuredEpisode) return null;
      return {
        "background-image": `
          linear-gradient(to right, #131212, #0001 50%),
          linear-gradient(to top, #131212, #0001 30%),
          url('${this.featuredEpisode.picture ||
            this.featuredEpisode.thumbnail_vimeo}')`
      };
    }
  },
  methods: {
    read(resource) {
      if (resource.external_link) {
        window.open(resource.external_link, "_blank");
      } else if (isMobile(window.navigator).any) {
        window.open(resource.file, "_blank");
      } else {
        this.selectedFile = resource;
        this.reading = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.view-trail-lesson {
  header {
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
  }
}
</style>
